module.exports = __webpack_public_path__ + "static/media/bolso (37).f38fccc0.jpg";